import { useModalStore } from '@/shared/lib/store/model/modal.store';
import { Icon, ModalLayout } from '@/shared/ui';
import React from 'react';

export const PublishPasswordEditCompletePopup = () => {
    const { closeModal } = useModalStore();
    return (
        <ModalLayout title="안내" wrapClassNm="box-width1" contClassNm="cont-pd1">
            <div className="info-mark">
                <Icon icon="mark" />
            </div>
            <p className="pop-txt-style1">학생 비밀번호를 초기화했습니다!</p>
            <p className="pop-txt-style2">
                학생에게 비밀번호를 1234로 입력하여 로그인한 후<br />
                비밀번호를 다시 설정하도록 안내해 주세요.
            </p>
            <div
                className="btn-wrap btn-width1 // con-mt3"
                onClick={() => closeModal('password-edit-complete')}
            >
                <button className="btn btn-default medium blue">확인</button>
            </div>
        </ModalLayout>
    );
};
